import App from './SteelPlateApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iSteelPlate', <App />);
